import { useRef, useState } from 'react';
import { SCROLL_PHOTOS } from '../config/scroll';
import Lightbox from './Lightbox';

function ArrowIcon({ direction }) {
  return (
    <svg
      width="28"
      height="12"
      viewBox="0 0 28 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={direction === 'left' ? 'rotate-180' : ''}
    >
      <path d="M1 6H26M26 6L21 1M26 6L21 11" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

function PhotoScroll({ photos = SCROLL_PHOTOS }) {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;

    const firstItem = container.querySelector('[data-scroll-item]');
    const gap = parseFloat(getComputedStyle(container).gap) || 12;
    const step = firstItem ? firstItem.offsetWidth + gap : container.clientWidth * 0.8;

    container.scrollBy({ left: direction * step, behavior: 'smooth' });
  };

  const openLightbox = (index) => setActiveIndex(index);
  const closeLightbox = () => setActiveIndex(null);

  const changeLightbox = (index) => {
    if (index < 0 || index >= photos.length) return;
    setActiveIndex(index);
  };

  if (photos.length === 0) {
    return null;
  }

  return (
    <>
      <section className="bg-white py-10 md:py-16">
        <div
          ref={scrollRef}
          className="scrollbar-hide flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth px-5 md:gap-5 md:px-10"
        >
          {photos.map((src, index) => (
            <button
              key={src}
              type="button"
              data-scroll-item
              onClick={() => openLightbox(index)}
              aria-label="Открыть фото на весь экран"
              className="shrink-0 cursor-pointer border-0 bg-transparent p-0 snap-start"
            >
              <img
                src={src}
                alt=""
                className="aspect-[3/4] h-[320px] w-auto object-cover md:h-[420px]"
                loading="lazy"
              />
            </button>
          ))}
        </div>

        {photos.length > 1 && (
          <div className="mt-8 flex items-center justify-center gap-12 md:mt-10">
            <button
              type="button"
              onClick={() => scroll(-1)}
              aria-label="Предыдущие фото"
              className="cursor-pointer border-0 bg-transparent p-2 text-black transition-opacity hover:opacity-50"
            >
              <ArrowIcon direction="left" />
            </button>
            <button
              type="button"
              onClick={() => scroll(1)}
              aria-label="Следующие фото"
              className="cursor-pointer border-0 bg-transparent p-2 text-black transition-opacity hover:opacity-50"
            >
              <ArrowIcon direction="right" />
            </button>
          </div>
        )}
      </section>

      <Lightbox
        photos={photos}
        activeIndex={activeIndex}
        onClose={closeLightbox}
        onChange={changeLightbox}
      />
    </>
  );
}

export default PhotoScroll;
